import Navigation from './../../components/feature/Navigation';
import Footer from './../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import RetreatDetailsSection from './components/RetreatDetailsSection';
import AccommodationGallerySection from './components/AccommodationGallerySection';
import ExperiencesSection from './components/ExperiencesSection';
import ScheduleSection from './components/ScheduleSection';
import ReservationSection from './components/ReservationSection';
import NewsletterSection from './components/NewsletterSection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <main>
        <HeroSection />
        <AboutSection />
        <RetreatDetailsSection />
        <AccommodationGallerySection />
        <ExperiencesSection />
        <ScheduleSection />
        <ReservationSection />
        <NewsletterSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;